import { Button } from "@/shared/ui/Button";

type DateTimeActionsProps = {
  onClear: () => void
  onConfirm: () => void
  canConfirm: boolean
};

export const DateTimeActions = ({ onClear, onConfirm, canConfirm }: DateTimeActionsProps) => (
  <div className="sticky bottom-0 flex gap-2 border-t bg-popover px-3 pb-3 pt-2">
    <Button
      variant="outline"
      size="sm"
      className="flex-1"
      onClick={onClear}
    >
      Effacer
    </Button>
    <Button
      variant="action"
      size="sm"
      className="flex-1"
      onClick={onConfirm}
      disabled={!canConfirm}
    >
      Confirmer
    </Button>
  </div>
);
